
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/fec15a463248d6a9",
      function () {
        return require("private-next-pages/special/fec15a463248d6a9/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/fec15a463248d6a9"])
      });
    }
  